import { searchParam } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { DashboardDetailsPage } from '@/areas/market-insights/MarketInsights/pages/DashboardDetailsPage';
import type { PageStaticData } from '@/shared/routing';

// The monitoring layout (`monitoring/route.tsx`) checks who may open this page.
export const Route = createFileRoute('/_authenticated/monitoring/_sidebar/dashboards/$dashboardId')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: z.object({ chartIds: searchParam.list('optional') }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <DashboardDetailsPage {...pathParams} />;
}
